(function() {
  // Кастомний слайдер без Swiper
  function initCustomSlider(sliderWrapper) {
    if (!sliderWrapper) return;
    
    const sliderTrack = sliderWrapper.querySelector('.featured-collection__slider-track');
    const sliderContainer = sliderWrapper.querySelector('.featured-collection__slider-container');
    const sliderNav = sliderWrapper.closest('.featured-collection__slider-wrapper')?.querySelector('.featured-collection__slider-nav');
    const prevBtn = sliderNav?.querySelector('.featured-collection__slider-btn--prev');
    const nextBtn = sliderNav?.querySelector('.featured-collection__slider-btn--next');
    const slides = sliderContainer.querySelectorAll('.swiper-slide, .grid__item:not(.featured-collection__cta-link-wrapper)');
    
    if (!sliderTrack || !sliderContainer || slides.length === 0) return;
    
    // Each slider has its own state
    let currentPosition = 0;
    let isAnimating = false;
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    let hasMoved = false;
    let touchStartTarget = null;
    let touchStartPosition = 0;
    let mouseDown = false;
    let mouseStartX = 0;
    
    // Отримуємо налаштування
    const mobileColumns = parseInt(sliderWrapper.dataset.mobileColumns) || 2;
    const tabletColumns = parseInt(sliderWrapper.dataset.tabletColumns) || 3;
    const desktopColumns = parseInt(sliderWrapper.dataset.desktopColumns) || 4;
    
    // Обчислюємо розміри
    function getSlidesPerView() {
      if (window.innerWidth <= 767) {
        // На мобільних: показуємо одну картку (82.5% ширини)
        return 1;
      }
      let columns = mobileColumns;
      if (window.innerWidth >= 1200) {
        columns = 5; // 5-6 картинок на екран більше 1200px
      } else if (window.innerWidth >= 1024) {
        columns = Math.min(desktopColumns, 5); // Ensure max 5-6 visible
      } else if (window.innerWidth >= 768) {
        columns = tabletColumns;
      }
      return columns;
    }
    
    function getSlideWidth() {
      const containerWidth = sliderTrack.offsetWidth;
      
      // На мобільних: картка з max-width 255px (як на десктопі)
      if (window.innerWidth <= 767) {
        const maxCardWidth = 255;
        // Використовуємо реальну ширину картки або max-width
        const firstSlide = slides[0];
        if (firstSlide) {
          const actualWidth = firstSlide.offsetWidth;
          return Math.min(actualWidth, maxCardWidth);
        }
        return maxCardWidth;
      }
      
      const gap = 10;
      const maxCardWidth = 255; // max-width картки (15% reduction)
      const columns = getSlidesPerView();
      
      // Обчислюємо ширину слайду з урахуванням max-width картки
      const calculatedWidth = (containerWidth - (gap * (columns - 1))) / columns;
      const slideWidth = Math.min(calculatedWidth, maxCardWidth);
      
      return slideWidth;
    }
    
    // Snap to nearest card boundary
    function snapToCard(position) {
      if (window.innerWidth <= 767) {
        const cardWidth = getSlideWidth();
        const gap = 12;
        const step = cardWidth + gap;
        
        // Round to nearest card position
        const snappedPosition = Math.round(position / step) * step;
        return Math.max(0, snappedPosition);
      }
      
      // Desktop: snap to card group
      const cardWidth = getSlideWidth();
      const slidesPerView = getSlidesPerView();
      const gap = 10;
      const step = (cardWidth * slidesPerView) + (gap * slidesPerView);
      const snappedPosition = Math.round(position / step) * step;
      return Math.max(0, snappedPosition);
    }
    
    function getMaxScroll() {
      const containerWidth = sliderTrack.offsetWidth;
      const totalSlides = slides.length;
      const ctaLinkWrapper = sliderContainer.querySelector('.featured-collection__cta-link-wrapper');
      const ctaLinkWidth = ctaLinkWrapper ? ctaLinkWrapper.offsetWidth : 0;
      
      if (totalSlides === 0) return 0;
      
      // На мобільних: обмежуємо максимум 6 карток
      const visibleSlides = window.innerWidth <= 767 
        ? Math.min(totalSlides, 6) 
        : totalSlides;
      
      if (window.innerWidth <= 767) {
        // Мобільний режим: використовуємо реальні розміри елементів
        if (visibleSlides <= 1) {
          return 0;
        }
        
        // Use actual scroll width for accurate max scroll calculation
        const containerScrollWidth = sliderContainer.scrollWidth;
        const trackWidth = sliderTrack.offsetWidth;
        
        // Ensure last card/CTA is fully visible by using actual scroll dimensions
        const maxScroll = Math.max(0, containerScrollWidth - trackWidth);
        
        return maxScroll;
      }
      
      // Десктопний режим
      const gap = 10;
      const maxCardWidth = 255; // 15% reduction
      const columns = getSlidesPerView();
      const calculatedWidth = (containerWidth - (gap * (columns - 1))) / columns;
      const cardWidth = Math.min(calculatedWidth, maxCardWidth);
      const totalWidth = (cardWidth * visibleSlides) + (gap * (visibleSlides - 1)) + (ctaLinkWidth > 0 ? ctaLinkWidth + gap : 0);
      const pageGutter = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--page-gutter')) || 24;
      const extraPadding = (pageGutter * 2) + cardWidth + (ctaLinkWidth > 0 ? ctaLinkWidth : 0);
      const maxScroll = Math.max(0, totalWidth - containerWidth + extraPadding);
      
      return maxScroll;
    }
    
    function updateButtons() {
      const maxScroll = getMaxScroll();
      const isAtStart = currentPosition <= 1; // Допуск для округлення
      const isAtEnd = currentPosition >= maxScroll - 1; // Допуск для округлення
      
      if (prevBtn) {
        prevBtn.disabled = isAtStart;
      }
      
      if (nextBtn) {
        nextBtn.disabled = isAtEnd;
      }
    }
    
    function scrollTo(position, animate = true) {
      if (isAnimating) return;
      
      const maxScroll = getMaxScroll();
      // Snap to card boundary for proper alignment
      const snappedPosition = snapToCard(position);
      currentPosition = Math.max(0, Math.min(maxScroll, snappedPosition));
      
      if (animate) {
        isAnimating = true;
        sliderContainer.style.transition = 'transform 0.3s ease-out';
      } else {
        sliderContainer.style.transition = 'none';
      }
      
      sliderContainer.style.transform = `translateX(-${currentPosition}px)`;
      
      if (animate) {
        setTimeout(() => {
          isAnimating = false;
          updateButtons();
        }, 300);
      } else {
        updateButtons();
      }
    }
    
    function slideNext() {
      const cardWidth = getSlideWidth();
      const slidesPerView = getSlidesPerView();
      const gap = window.innerWidth <= 767 ? 12 : 10;
      // На мобільних: прокручуємо на одну картку + gap
      // На десктопі: ширина карток + gap між ними
      const step = window.innerWidth <= 767 
        ? cardWidth + gap 
        : (cardWidth * slidesPerView) + (gap * slidesPerView);
      scrollTo(currentPosition + step);
    }
    
    function slidePrev() {
      const cardWidth = getSlideWidth();
      const slidesPerView = getSlidesPerView();
      const gap = window.innerWidth <= 767 ? 12 : 10;
      // На мобільних: прокручуємо на одну картку + gap
      // На десктопі: ширина карток + gap між ними
      const step = window.innerWidth <= 767 
        ? cardWidth + gap 
        : (cardWidth * slidesPerView) + (gap * slidesPerView);
      scrollTo(currentPosition - step);
    }
    
    // Обробники кнопок
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (currentPosition > 0) {
          slidePrev();
        }
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const maxScroll = getMaxScroll();
        if (currentPosition < maxScroll) {
          const cardWidth = getSlideWidth();
          const gap = window.innerWidth <= 767 ? 12 : 10;
          const step = window.innerWidth <= 767 ? cardWidth + gap : (cardWidth * getSlidesPerView()) + (gap * getSlidesPerView());
          
          // Перевіряємо, чи не перевищимо максимальну прокрутку
          const newPosition = currentPosition + step;
          if (newPosition > maxScroll) {
            scrollTo(maxScroll);
          } else {
            slideNext();
          }
        }
      });
    }
    
    // Mouse drag support for desktop - scoped to this slider
    const handleMouseMove = function(e) {
      if (!mouseDown || !isDragging) return;
      currentX = e.clientX;
      const diff = startX - currentX;
      
      if (Math.abs(diff) > 5) {
        hasMoved = true;
      }
      
      const newPosition = currentPosition + diff;
      const maxScroll = getMaxScroll();
      const constrainedPosition = Math.max(0, Math.min(maxScroll, newPosition));
      sliderContainer.style.transform = `translateX(-${constrainedPosition}px)`;
    };
    
    const handleMouseUp = function(e) {
      if (!mouseDown) return;
      mouseDown = false;
      sliderTrack.style.cursor = '';
      
      if (!isDragging) return;
      
      const diff = startX - currentX;
      const threshold = 50;
      
      const clickedElement = touchStartTarget;
      const isClickOnProduct = clickedElement && (
        clickedElement.closest('.product-card') !== null || 
        clickedElement.closest('a') !== null ||
        clickedElement.closest('button') !== null
      );
      
      if (isClickOnProduct && !hasMoved) {
        sliderContainer.style.transition = 'none';
        sliderContainer.style.transform = `translateX(-${touchStartPosition}px)`;
        currentPosition = touchStartPosition;
        isDragging = false;
        hasMoved = false;
        updateButtons();
        return;
      }
      
      isDragging = false;
      
      const newPosition = touchStartPosition + diff;
      const maxScroll = getMaxScroll();
      const constrainedPosition = Math.max(0, Math.min(maxScroll, newPosition));
      
      if (Math.abs(diff) > threshold && hasMoved) {
        if (diff > 0) {
          // Swipe right - go to next card
          const cardWidth = getSlideWidth();
          const gap = window.innerWidth <= 767 ? 12 : 10;
          const step = window.innerWidth <= 767 ? cardWidth + gap : (cardWidth * getSlidesPerView()) + (gap * getSlidesPerView());
          const targetPosition = snapToCard(touchStartPosition + step);
          scrollTo(targetPosition, true);
        } else {
          // Swipe left - go to previous card
          const cardWidth = getSlideWidth();
          const gap = window.innerWidth <= 767 ? 12 : 10;
          const step = window.innerWidth <= 767 ? cardWidth + gap : (cardWidth * getSlidesPerView()) + (gap * getSlidesPerView());
          const targetPosition = snapToCard(touchStartPosition - step);
          scrollTo(targetPosition, true);
        }
      } else if (hasMoved) {
        // Snap to nearest card
        const snappedPosition = snapToCard(constrainedPosition);
        scrollTo(snappedPosition, true);
      } else {
        // Snap to current position
        const snappedPosition = snapToCard(touchStartPosition);
        scrollTo(snappedPosition, true);
      }
      
      hasMoved = false;
    };
    
    sliderTrack.addEventListener('mousedown', function(e) {
      if (e.button !== 0) return; // Only left mouse button
      mouseDown = true;
      mouseStartX = e.clientX;
      startX = e.clientX;
      currentX = startX;
      touchStartPosition = currentPosition;
      isDragging = true;
      hasMoved = false;
      touchStartTarget = e.target;
      sliderContainer.style.transition = 'none';
      sliderTrack.style.cursor = 'grabbing';
      e.preventDefault();
      
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp, { once: true });
    });
    
    // Touch/Swipe підтримка
    sliderTrack.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      currentX = startX;
      touchStartPosition = currentPosition;
      isDragging = true;
      hasMoved = false;
      touchStartTarget = e.target;
      sliderContainer.style.transition = 'none';
    }, { passive: true });
    
    sliderTrack.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
      const diff = startX - currentX;
      
      // Відстежуємо, чи був реальний рух
      if (Math.abs(diff) > 5) {
        hasMoved = true;
      }
      
      const newPosition = currentPosition + diff;
      const maxScroll = getMaxScroll();
      const constrainedPosition = Math.max(0, Math.min(maxScroll, newPosition));
      sliderContainer.style.transform = `translateX(-${constrainedPosition}px)`;
    }, { passive: true });
    
    sliderTrack.addEventListener('touchend', function(e) {
      if (!isDragging) return;
      
      const diff = startX - currentX;
      const threshold = 50;
      
      // Перевіряємо, чи клік був на продукт або його дочірні елементи
      const clickedElement = e.target;
      const isClickOnProduct = clickedElement.closest('.product-card') !== null || 
                               clickedElement.closest('a') !== null ||
                               clickedElement.closest('button') !== null;
      
      // Якщо був клік на продукт без значного руху - не виконуємо скрол
      if (isClickOnProduct && !hasMoved) {
        // Повертаємо transform до початкової позиції без анімації
        sliderContainer.style.transition = 'none';
        sliderContainer.style.transform = `translateX(-${touchStartPosition}px)`;
        currentPosition = touchStartPosition;
        isDragging = false;
        hasMoved = false;
        updateButtons();
        // Дозволяємо click події спрацювати нормально
        return;
      }
      
      isDragging = false;
      
      // Оновлюємо currentPosition на основі поточного стану після перетягування
      const newPosition = touchStartPosition + diff;
      const maxScroll = getMaxScroll();
      const constrainedPosition = Math.max(0, Math.min(maxScroll, newPosition));
      
      // Якщо був значний рух - виконуємо swipe з snap
      if (Math.abs(diff) > threshold && hasMoved) {
        if (diff > 0) {
          // Swipe right - go to next card
          const cardWidth = getSlideWidth();
          const gap = window.innerWidth <= 767 ? 12 : 10;
          const step = window.innerWidth <= 767 ? cardWidth + gap : (cardWidth * getSlidesPerView()) + (gap * getSlidesPerView());
          const targetPosition = snapToCard(touchStartPosition + step);
          scrollTo(targetPosition, true);
        } else {
          // Swipe left - go to previous card
          const cardWidth = getSlideWidth();
          const gap = window.innerWidth <= 767 ? 12 : 10;
          const step = window.innerWidth <= 767 ? cardWidth + gap : (cardWidth * getSlidesPerView()) + (gap * getSlidesPerView());
          const targetPosition = snapToCard(touchStartPosition - step);
          scrollTo(targetPosition, true);
        }
      } else if (hasMoved) {
        // Якщо був рух, але не достатній для swipe - snap до найближчої картки
        const snappedPosition = snapToCard(constrainedPosition);
        scrollTo(snappedPosition, true);
      } else {
        // Якщо не було руху - залишаємося на місці з snap
        const snappedPosition = snapToCard(touchStartPosition);
        scrollTo(snappedPosition, true);
      }
      
      hasMoved = false;
    }, { passive: true });
    
    // Обмежуємо кількість карток на мобільних до 6
    function limitMobileSlides() {
      if (window.innerWidth <= 767) {
        slides.forEach(function(slide, index) {
          if (index >= 6) {
            slide.style.display = 'none';
          } else {
            slide.style.display = '';
          }
        });
      } else {
        slides.forEach(function(slide) {
          slide.style.display = '';
        });
      }
    }
    
    // Завантажуємо всі зображення
    function loadAllImages() {
      slides.forEach(function(slide) {
        const images = slide.querySelectorAll('img');
        images.forEach(function(img) {
          if (img.loading === 'lazy') {
            img.loading = 'eager';
          }
          if (img.fetchPriority !== 'high') {
            img.fetchPriority = 'high';
          }
          if (img.complete) {
            img.classList.add('loaded');
            img.style.opacity = '1';
          } else {
            img.onload = function() {
              this.classList.add('loaded');
              this.style.opacity = '1';
            };
          }
        });
      });
    }
    
    // Ініціалізація
    limitMobileSlides();
    loadAllImages();
    updateButtons();
    
    // Обробка зміни розміру вікна - scoped to this slider
    let resizeTimeout;
    const handleResize = function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        limitMobileSlides();
        // Перераховуємо позицію з урахуванням нового розміру
        const maxScroll = getMaxScroll();
        if (currentPosition > maxScroll) {
          currentPosition = maxScroll;
        }
        scrollTo(currentPosition, false);
        updateButtons();
      }, 250);
    };
    window.addEventListener('resize', handleResize);
  }
  
  // Ініціалізація всіх слайдерів на сторінці
  function initAllSliders() {
    const allSliders = document.querySelectorAll('.featured-collection__custom-slider');
    allSliders.forEach(function(sliderWrapper) {
      initCustomSlider(sliderWrapper);
    });
  }
  
  // Ініціалізація після завантаження DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initAllSliders, 100);
    });
  } else {
    setTimeout(initAllSliders, 100);
  }
  
  // Re-initialize when new sections are loaded (for theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const newSlider = event.detail.querySelector('.featured-collection__custom-slider');
      if (newSlider) {
        setTimeout(function() {
          initCustomSlider(newSlider);
        }, 100);
      }
    });
  }
})();






